import { __rest } from 'tslib';
import Link from 'next/link';
import React__default from 'react';
import { styled } from '@teko/styled';

const CustomLink = (_a) => {
    var { href, children, passHref = true, target = '_self' } = _a, others = __rest(_a, ["href", "children", "passHref", "target"]);
    if (!href) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return (React__default.createElement(Link, Object.assign({ href: href }, others, { passHref: passHref }),
        React__default.createElement(Anchor, { target: target }, children)));
};
const Anchor = styled.a `
  text-decoration: none;
  color: unset;
  &:hover {
    color: unset;
  }
  cursor: pointer;
`;

export { CustomLink as C };
